import React from 'react';

const DeleteIcon = ({ onClick, disabled = false }) => (
  // <svg
  //   className="archive-icon"
  //   width="14"
  //   height="14"
  //   viewBox="0 0 14 14"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   onClick={onClick}
  // >
  //   <path d="M2.625 15C2.14375 15 1.73192 14.8369 1.3895 14.5108C1.04708 14.1847 0.875583 13.7922 0.875 13.3333V2.5H0V0.833333H4.375V0H9.625V0.833333H14V2.5H13.125V13.3333C13.125 13.7917 12.9538 14.1842 12.6114 14.5108C12.269 14.8375 11.8568 15.0006 11.375 15H2.625ZM4.375 11.6667H6.125V4.16667H4.375V11.6667ZM7.875 11.6667H9.625V4.16667H7.875V11.6667Z" fill="#BD3D44"/>  </svg>

    <svg
      className="archive-icon"
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.4 : 1,
        transition: "opacity 0.2s ease"
      }}

     xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M2.25 4.5H15.75" stroke="#D9002F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.25 4.5V15C14.25 15.75 13.5 16.5 12.75 16.5H5.25C4.5 16.5 3.75 15.75 3.75 15V4.5" stroke="#D9002F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 4.5V3C6 2.25 6.75 1.5 7.5 1.5H10.5C11.25 1.5 12 2.25 12 3V4.5" stroke="#D9002F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.5 8.25V12.75" stroke="#D9002F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10.5 8.25V12.75" stroke="#D9002F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

export default DeleteIcon;